import { Component } from 'react';
import { SquareButton } from './styles';

interface PageButtonProps {
    onClick: (page: number) => void;
    value: number;
    isSelected?: boolean;
}

class PageButton extends Component<PageButtonProps> {
    handleClick = () => {
        this.props.onClick(this.props.value);
    };

    render() {
        const { children, isSelected, onClick, value, ...other } = this.props;

        return (
            <SquareButton
                onClick={!isSelected ? this.handleClick : undefined}
                size="small"
                variant="ghost"
                disabled={isSelected}
                {...other}
            >
                {children}
            </SquareButton>
        );
    }
}

export default PageButton;
